import { Box, Button, Grid } from "@mui/material"
import { EditActivityForm } from "./types"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { Left } from "./components/left"
import { useBody } from "./hooks/body"
import Loader from "../../../../../../../../components/loader"
import { useEffect } from "react"
import SimpleModal from "../../../../../../../../components/modal/simpleModal"
import { SnackSimple } from "../../../../../../../../components"
import { LoadingButton } from "@mui/lab"
import { Right } from "./components/right"
import { useCreatEdit } from "./hooks/useForm"
import { useInput } from "./hooks/useInput"
import { ActivityWithGeofence } from "./components/activityWithGeofence"

export const EditActivity = ({ goBack }: EditActivityForm) => {
    const { t } = useTranslation()
    const styles = useStyles()
    const { dataDestination, handleDataDestination, onChangeDestination, dataActivity, handleChangeCrud, handleDataActivity, onChangeCrud } = useCreatEdit()
    const { setInputLastActivity, filter, filterUnity, formatFilter, formatFilterUnity, inputDestination, inputFilter, inputFilterUnity, inputLastActivity, openField, inputActivity, inputSecondActivity } = useInput()
    const { handleSubmitDestionatio, closeSimpleModal, openSimple, companies, destinatioCreated, statusLocale, isPartner, isFree, geofence, oldTypeDestination, disableActivityFormLast, disableActivityFormSecond, setOldTypeDestination, handleSubmitActivity, errors, setErrors, countOfEvidences, status, activityId, configEvidences, closeSnackbar, evidenceUpload, evidences, existEvidences, snackbar, submitEvidences, openModal, handleCancelEdit, closeModal, disableActivityForm, edit, setEdit, handleRowClickUser, setDefaultValues, handleRowClickUnity, setUserToFinal, setUser, tableUsers, user, userFinal, setUserFinal, loading, totalPages, setUnityToDestination, setDestinationFinal, setDestination, destination, tableUnits, defaultValues, getDate, isToBiggerThanFrom, setIsToBiggerThanFrom, destinationFinal } = useBody(filterUnity, formatFilterUnity, filter, handleDataActivity, formatFilter, dataActivity, inputActivity, inputSecondActivity, inputLastActivity)

    useEffect(() => {
        if (dataActivity?.title == '') {
            const { title, ...rest } = dataActivity;
            handleDataActivity(rest);
        }
    }, [dataActivity?.title])

    return (
        <Box sx={{ padding: 3 }}>

            {loading.activityData ? (
                <Loader />
            ) : (<>
                {!geofence ? (
                    <Box>
                        <Grid container sx={{ minHeight: '600px' }}>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                <Left
                                    evidenceUpload={evidenceUpload}
                                    isFree={isFree}
                                    evidences={evidences}
                                    existEvidences={existEvidences}
                                    getEvidence={submitEvidences}
                                    status={status}
                                    evidenceConfig={configEvidences}
                                    statusLocale={statusLocale}
                                    inputActivity={inputActivity}
                                    inputSecondActivity={inputSecondActivity}
                                    inputLastActivity={inputLastActivity}
                                    defaultValues={defaultValues}
                                    getDate={getDate}
                                    isToBiggerThanFrom={isToBiggerThanFrom}
                                    setIsToBiggerThanFrom={setIsToBiggerThanFrom}
                                    dataActivity={dataActivity}
                                    handleChangeCrud={handleChangeCrud}
                                    handleDataActivity={handleDataActivity}
                                    onChangeCrud={onChangeCrud}
                                    destinationFinal={destinationFinal}
                                    setDefaultValues={setDefaultValues}
                                    edit={edit}
                                    activityId={activityId}
                                    disabledButton={!dataActivity?.typeOfActivity}
                                    badgeContent={countOfEvidences}
                                    errors={errors}
                                    setErrors={setErrors}
                                    oldTypeDestination={oldTypeDestination}
                                    openField={openField}
                                    setInputLastActivity={setInputLastActivity}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                <Right
                                    destinationFinal={destinationFinal}
                                    companies={companies}
                                    destinatioCreated={destinatioCreated}
                                    isPartner={isPartner}
                                    tableUnits={tableUnits}
                                    inputFilterUnity={inputFilterUnity}
                                    filterUnity={filterUnity}
                                    inputDestination={inputDestination}
                                    destination={destination}
                                    setUnityToDestination={setUnityToDestination}
                                    setDestination={setDestination}
                                    setDestinationFinal={setDestinationFinal}
                                    dataDestination={dataDestination}
                                    handleDataDestination={handleDataDestination}
                                    onChangeDestination={onChangeDestination}
                                    loading={loading}
                                    totalPages={totalPages}
                                    user={user}
                                    userFinal={userFinal}
                                    inputFilter={inputFilter}
                                    filter={filter}
                                    tableUsers={tableUsers}
                                    setUserFinal={setUserFinal}
                                    setUserToFinal={setUserToFinal}
                                    setUser={setUser}
                                    handleRowClickUser={handleRowClickUser}
                                    handleRowClickUnity={handleRowClickUnity}
                                    setEdit={setEdit}
                                    setOldTypeDestination={setOldTypeDestination}
                                />
                            </Grid>
                        </Grid>

                        <Box sx={styles.buttonsContainer}>
                            <Button onClick={handleCancelEdit}>{t('general.cancel')}</Button>
                            <LoadingButton loading={loading.editActivity} disabled={disableActivityForm || disableActivityFormLast || disableActivityFormSecond || !userFinal || !destinationFinal || (!isFree && (!defaultValues.to || !defaultValues.from || !!(errors.to)))} className="next" variant="contained" onClick={(destinationFinal?.idDestnation && !destinationFinal.toCreateSelected) ? handleSubmitDestionatio : ()=>{handleSubmitActivity({toCreate:false})}}>
                                {t('general.edit')}
                            </LoadingButton>
                        </Box>
                    </Box >
                ) : (
                    <Box>
                        <ActivityWithGeofence
                            evidenceUpload={evidenceUpload}
                            evidences={evidences}
                            existEvidences={existEvidences}
                            getEvidence={submitEvidences}
                            status={status}
                            evidenceConfig={configEvidences}
                            statusLocale={statusLocale}
                            inputActivity={inputActivity}
                            inputSecondActivity={inputSecondActivity}
                            inputLastActivity={inputLastActivity}
                            dataActivity={dataActivity}
                            handleDataActivity={handleDataActivity}
                            onChangeCrud={onChangeCrud}
                            activityId={activityId}
                            disabledButton={!dataActivity?.typeOfActivity}
                            badgeContent={countOfEvidences}
                            openField={openField}
                            setInputLastActivity={setInputLastActivity}
                        />
                        <Box sx={styles.buttonsContainer}>
                            <Button onClick={handleCancelEdit}>{t('general.cancel')}</Button>
                            <LoadingButton loading={loading.editActivity} disabled={disableActivityForm || disableActivityFormLast || disableActivityFormSecond} className="next" variant="contained" onClick={(destinationFinal?.idDestnation && !destinationFinal.toCreateSelected) ? handleSubmitDestionatio : ()=>{handleSubmitActivity({toCreate:false})}}>
                                {t('general.edit')}
                            </LoadingButton>
                        </Box>
                    </Box>
                )}

            </>)}

            <SnackSimple close={closeSnackbar} open={snackbar.open} type={snackbar.type} message={snackbar.message} />

            <SimpleModal
                open={openModal.open}
                close={() => {
                    closeModal()
                }}
                title={openModal?.title}
                description={openModal?.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                back={() => {
                    if (openModal?.cancel) {
                        openModal.cancel()
                    } else {
                        closeModal()
                    }
                }}
                next={() => {
                    if (openModal?.confirm) {
                        openModal.confirm()
                    }
                }}
            />

            <SimpleModal
                open={openSimple.open}
                close={() => { closeSimpleModal() }}
                removeClose
                title={openSimple.title}
                description={openSimple.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                back={openSimple?.cancel ?? undefined}
                next={openSimple.confirm ?? closeSimpleModal}
            />

        </Box >
    )
}